function getImages () {
  let files = require.context('../assets/images/banklogo', true, /.png/).keys()
  files.fileList = []
  for (let j = 0; j < files.length; j++) {
    files.fileList.push()
    const name = files[j].slice(2, -4)
    const fileContext = require(`../assets/images/banklogo/${name}.png`)
    files.fileList.push({
      name: name,
      fileContext: fileContext
    })
  }
  return files
}
export { getImages }
